// src/tools/measurement/coordsTool.js
import maplibregl from 'maplibre-gl';

export const coordsTool = {
  _map: null,
  _marker: null,
  _onCoordsSelect: null,

  initialize: (map, options) => {
    console.log('Coords tool initialized');
    coordsTool._map = map;
    coordsTool._onCoordsSelect = options.onCoordsSelect;
  },
  activate: () => {
    console.log('Coords tool activated');
    coordsTool._map.getCanvas().style.cursor = 'crosshair';
    coordsTool._map.on('click', coordsTool.handleMapClick);
  },
  deactivate: () => {
    console.log('Coords tool deactivated');
    coordsTool._map.getCanvas().style.cursor = '';
    coordsTool._map.off('click', coordsTool.handleMapClick);
    coordsTool.cleanup();
  },
  cleanup: () => {
    if (coordsTool._marker) {
      coordsTool._marker.remove();
      coordsTool._marker = null;
    }
  },
  handleMapClick: (e) => {
    coordsTool.cleanup(); // Удаляем предыдущий маркер и попап

    const { lng, lat } = e.lngLat;
    const rawFeatures = coordsTool._map.queryRenderedFeatures(e.point);

    // Очищаем и нормализуем объекты, чтобы у каждого был ID
    const seenIds = new Set();
    const features = rawFeatures
      .map(feature => {
        // Приоритет: feature.id (от promoteId), затем feature.properties.id
        // Если promoteId не сработало, то feature.id будет undefined.
        // В этом случае используем feature.properties.id.
        const id = feature.id || feature.properties?.id;
        // Если ID нет или мы его уже видели - пропускаем объект.
        if (!id || seenIds.has(id)) return null;
        seenIds.add(id);
        return feature; // Возвращаем исходный объект, он уже содержит все что нужно
      }).filter(Boolean); // Убираем null

    // Вызываем колбэк для открытия панели в главном компоненте
    coordsTool._onCoordsSelect?.({ coordinates: { lng, lat }, features });

    coordsTool._marker = new maplibregl.Marker().setLngLat(e.lngLat).addTo(coordsTool._map);
  },
};